import {createRouter, createWebHistory, NavigationGuardNext, RouteLocationNormalized, RouteRecordRaw} from 'vue-router'
import {useStore} from 'vuex'
import MainPageLayout from '@/layout/MainPageLayout.vue'
import request from '@/utils/request'
import {BasicsRouter} from '@/router/modules/basics'
import {CpesRouter} from '@/router/modules/cpes'
import {StatsRouter} from '@/router/modules/stats'
import {PaymentsRouter} from '@/router/modules/payments'
import {KeywordsRouter} from '@/router/modules/keywords'
import {NotificationRouter} from '@/router/modules/notification'
import {PlatformOperateRouter} from '@/router/modules/platformOperate'
import {SettlementRouter} from '@/router/modules/settlement'
import {KocRouter} from '@/router/modules/koc'
import {ResourcesRouter} from '@/router/modules/resources'
import {RelativesLeaderRouter} from '@/router/modules/relativesLeader'
import {RelativesDirectorRouter} from '@/router/modules/relativesDirector'
import {TaskRouter} from '@/router/modules/task'

const routes: Array<RouteRecordRaw> = [
  // 注册/登录等
  {
    path: '/',
    name: 'Login',
    component: () => import('@/views/Login/Index.vue'),
    meta: {
      isAuth: false,
    },
  },
  
  {
    path: '/keywords',
    name: 'Keywords',
    component: MainPageLayout,
    children: [
      // 首页
      {
        path: 'home',
        name: 'Dashboard',
        component: () => import('@/views/Dashboard/Index.vue'),
        meta: {
          key: 'home'
        },
      },

      ...BasicsRouter,
      ...CpesRouter,
      ...StatsRouter,
      ...PaymentsRouter,
      ...KeywordsRouter,
      ...NotificationRouter,
      ...PlatformOperateRouter,
      ...SettlementRouter,
      ...KocRouter,
      ...ResourcesRouter,
      ...RelativesLeaderRouter,
      ...RelativesDirectorRouter,
      ...TaskRouter,

      {
        path: 'upload',
        name: 'SettingUpload',
        component: () => import('@/views/Setting/UploadPage.vue'),
        meta: {
          key: 'setting'
        }
      },
    ],
  },
  {
    path: '/test',
    name: 'Test',
    component: () => import('@/views/Test.vue'),
    meta: {
      isAuth: false,
    },
  },
  {
    path: '/404',
    name: '404',
    component: () => import('@/views/404.vue'),
    meta: {
      isAuth: false,
    },
  },
  {
    path: '/:catchAll(.*)', // 404 页面
    redirect: '/',
    meta: {
      isAuth: false,
    },
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach(async (to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext) => {
  const store = useStore()
  
  if (!store.state.platforms.length) {
    
    await request.get(
      '/api/platforms'
    ).then((res: any) => {
      
      const data = res.data?.platforms?.filter(v=>v.status==1)
      const platform:any = []
      data.forEach((v:any)=>{
        platform.push({value:v.platform,label:v.product_name})
      })
      
      store.commit("setPlatforms", platform)
      store.commit("setPlatformsData", data)
    }).catch((err) => {
      console.log('err', err);
      
    })
  }
  next()
})

export default router
